import React from 'react'
import { useLocation } from 'react-router-dom'
import { TabPanel } from './TabPanel'
import { Summary } from '../../Summary'
import { Analysis } from '../../Analysis'
import { Rosters } from '../../Rosters'
import { TabHeaderStyle } from '../../../../Components/Tab/styles'
import { Tab } from '../../../../Components/LazyComponents'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const MatchupTabs: React.FC<React.PropsWithChildren<unknown>> = () => {
  let query = useQuery()
  const tabQuery = query.get('tab')
  const tab = tabQuery === 'roster' ? 2 : tabQuery === 'fan' ? 3 : 0
  const [value, setValue] = React.useState(tab)

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  return (
    <>
      <TabHeaderStyle
        tabColor="dark"
        topRadius={8}
        value={value}
        onChange={handleChange}
        aria-label="matchup tabs"
      >
        <Tab label="Analysis" />
        <Tab label="Summary" />
        <Tab label="Rosters" />
      </TabHeaderStyle>
      <TabPanel value={value} index={0}>
        <Analysis />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Summary />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Rosters />
      </TabPanel>
    </>
  )
}
